import { Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconHeart } from "@tabler/icons-react";
import SaveFavouriteModal from "src/generator/_Modals/FavouritesModal/SaveFavouriteModal";
import { useCheckPerm, useIsNewEntry } from "src/hooks";
import { useSelector } from "src/redux/hooks";

const SaveFavouriteButton = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const isNewEntry = useIsNewEntry();
  const checkPerm = useCheckPerm();
  const favourites = useSelector(
    state => state.generatorSlice.lbentry.favourites,
  );

  if (!favourites || !checkPerm("createentries")) {
    return <></>;
  }

  return (
    <>
      <Menu.Item
        disabled={isNewEntry}
        onClick={open}
        leftSection={<IconHeart size={20} />}>
        Save as Favourite
      </Menu.Item>
      <SaveFavouriteModal opened={opened} close={close} />
    </>
  );
};

export default SaveFavouriteButton;
